import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { HostActivityType } from "#src/services/endpoint/devices/enums";
import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";
import { useFilter } from "#src/commonV2/Table/Filter/useFilter";
import { SearchboxV2 } from "#src/commonV2/Table/Searchbox";
import { FilterDropdownV2 } from "#src/commonV2/Table/Filter/FilterDropdown";

type Props = {
  searchKeyword: string;
  setSearchKeyword: (keyword: string) => void;
  setSelectedPage: (page: number) => void;
  activityType: IFilterItemV2 | null;
  setActivityType: (vulnerable: IFilterItemV2 | null) => void;
};

export const ActivityFilter = (props: Props) => {
  const {
    searchKeyword,
    setSearchKeyword,
    setSelectedPage,
    setActivityType,
    activityType,
  } = props;

  const { t } = useTranslation("endpoint", { keyPrefix: "devices" });

  // ----------------------------- PARAMS -----------------------------

  // ----------------------------- COMPUTED -----------------------------

  const activityItems: IFilterItemV2[] = useMemo(
    () =>
      Object.values(HostActivityType).map((item) => ({
        key: item,
        value: item,
        getLabel: () => t(`activities.activity.${item}`) as string,
      })),
    [t]
  );

  // ----------------------------- HOOKS -----------------------------

  const { renderProps: activityFilterRenderProps, value: activityValue } =
    useFilter({
      label: t("activities.activity.label"),
      selectionList: activityItems,
    });

  // ----------------------------- EFFECTS -----------------------------

  useEffect(() => {
    if (activityValue !== activityType?.value) {
      setActivityType(
        activityItems.find((item) => item.value === activityValue) ?? null
      );
      setSelectedPage(1);
    }
  }, [
    activityItems,
    activityType?.value,
    activityValue,
    setActivityType,
    setSelectedPage,
  ]);

  // ----------------------------- RENDER -----------------------------

  return (
    <div className="flex flex-col sm:flex-row justify-between gap-2">
      <FilterDropdownV2 {...activityFilterRenderProps} />
      <SearchboxV2
        value={searchKeyword}
        onChange={(value) => {
          setSearchKeyword(value);
          setSelectedPage(1);
        }}
        placeholder={t("common.search")}
      />
    </div>
  );
};
